jQuery("img.svg").each(function () {
    const $img = jQuery(this);
    const imgID = $img.attr("id");
    const imgClass = $img.attr("class");
    const imgURL = $img.attr("src");
    const imgStyle = $img.attr("style");

    //get all data attributes on img
    const imgData = $img.data();

    jQuery.get(
        imgURL,
        function (data) {
            let $svg = jQuery(data).find("svg");
            if (typeof imgID !== "undefined") {
                $svg = $svg.attr("id", imgID);
            }
            if (typeof imgClass !== "undefined") {
                $svg = $svg.attr("class", imgClass + " replaced-svg");
            }
            if (typeof imgStyle !== "undefined") {
                $svg = $svg.attr("style", imgStyle);
            }

            //set all data attributes on svg
            for (const key in imgData) {
                if (Object.hasOwnProperty.call(imgData, key)) {
                    const value = imgData[key];
                    $svg = $svg.attr("data-" + key, value);
                }
            }

            $svg = $svg.removeAttr("xmlns:a");
            if (
                !$svg.attr("viewBox") &&
                $svg.attr("height") &&
                $svg.attr("width")
            ) {
                $svg.attr(
                    "viewBox",
                    "0 0 " + $svg.attr("height") + " " + $svg.attr("width")
                );
            }
            $img.replaceWith($svg);
        },
        "xml"
    );
});

jQuery(".back-to-top").on("click", function () {
    jQuery("html, body").animate({ scrollTop: 0 }, "fast");
});
